<template>
  <div class="host page" style="margin-left:25px">
      <h3>
          РЕЕСТР ПАЦИЕНТОВ
      </h3>
    <div class="headSearch">
        <searchInput v-model="search" style="width:80%" />
        <router-link :to="{
              name: 'registry.patient.card.create', params: {item: {}}
            }" class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10 vm-button">
         Добавить пациента</router-link>
    </div>
    <DataTable
      title="Пациенты"
      :fields="tableFileds"
      :pageSize="50"
      :service="service"
      :withDialog="false"
      :withSearch="false"
      :withEditOrRoute="false"
      :searchOutside="search"
      @route-to="editPage($event)"
    >
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@app/components/uikit/DataTable';
import { patientApi } from '@app/services';
import searchInput from '@app/components/uikit/searchInput';
import vmbutton from '@app/components/uikit/VMButton';

export default {
    components: { DataTable, searchInput,  },
    data: () => ({
        service: patientApi,
        search: '',
        tableFileds: [
        {
            name: 'lastName',
            label: 'Фамилия'
        },
        {
            name: 'firstName',
            label: 'Имя'
        },
        {
            name: 'middleName',
            label: 'Отчество'
        },
        {
            name: 'birthDay',
            label: 'Дата рождения'
        },
        {
            name: 'cardid',
            label: 'Номер карты'
        },
        {
            name: 'phone',
            label: 'Номер телефона'
        },
        {
            name: 'gender',
            label: 'Пол'
        }
        ]
    }),
    mounted() {
    },
    methods: {
        editPage(evt) {
            this.$router.push({name: 'registry.patient.card', params: {uuidPatient: evt.id, item: evt}});
        }
    }
};
</script>


<style lang="scss" scoped>
    .headSearch {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-bottom: 10px;
        align-items: center;
    }

    .vm-button {
  padding: 10px 30px 10px 30px; 
  border-radius:25px; 
  background: linear-gradient(to right, #8C30DA, #5C48D4);
}
</style>